import { Component } from 'react';

class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-subtle">
          <div className="max-w-md w-full p-6 bg-default rounded-lg shadow-resting">
            <h2 className="text-2xl font-bold text-danger mb-4">Errore</h2>
            <p className="text-muted mb-4">{this.state.error.message}</p>
            <button
              onClick={() => window.location.reload()}
              className="w-full py-2 px-4 bg-primary text-on-emphasis rounded-md"
            >
              Ricarica
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
